import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { operatingModel, toolset } from '../../data/about';
import { operatingImages } from '../../data/aboutImages';
const operatingGroups = [operatingModel.slice(0, 2), operatingModel.slice(2, 4), operatingModel.slice(4, 6)];
export function HowWeWork() {
  return <Section bordered labelledBy="how-we-work-title" data-id="element-36" data-mp="944t2xbi3i1i">
      <Container data-id="element-37" data-mp="e3rbrma3lqhp">
        <Reveal data-id="element-38" data-mp="e37pjtdf0fxv">
          <h2 id="how-we-work-title" className="max-w-[16ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-39" data-mp="e2pwf5m1uhu6">
            How we actually work.
          </h2>
          <p className="mt-6 max-w-[52ch] text-body text-muted" data-id="element-40" data-mp="mvjf7d0pfzcs">
            The operating model, in the same detail we would give you on the first call. If any of
            it does not suit how your company runs, better to know now.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-10 lg:mt-16 lg:grid-cols-3" data-id="element-41" data-mp="3ay4zj9z5r16d">
          {operatingGroups.map((group, groupIndex) => <Reveal key={operatingImages[groupIndex].image} delay={groupIndex * 0.06} data-id="element-42" data-mp="35wfp9wjrerjc" data-mpi={groupIndex}>
              <AppImage src={operatingImages[groupIndex].image} alt={operatingImages[groupIndex].alt} ratio="4:3" data-id="element-43" data-mp="31x6ucoczgnm7" />
              <dl className="mt-8 border-t border-hairline" data-id="element-44" data-mp="3tntfnwycod1o">
                {group.map(item => <div key={item.label} className="border-b border-hairline py-8" data-id="element-45" data-mp="3pn14uz9ty03a">
                    <dt className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-46" data-mp="3kuq3drzfy68m">
                      {item.label}
                    </dt>
                    <dd data-id="element-47" data-mp="3fvwru53pspb3">
                      <p className="mt-4 text-[20px] leading-[1.3] tracking-[-0.02em] text-ink" data-id="element-48" data-mp="h66bqbiu3u2e">
                        {item.value}
                      </p>
                      <p className="mt-3 max-w-[36ch] text-small leading-6 text-muted" data-id="element-49" data-mp="cdvddd3qsgby">
                        {item.detail}
                      </p>
                    </dd>
                  </div>)}
              </dl>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} className="mt-16 lg:mt-20" data-id="element-50" data-mp="mibsu5db7vf8">
          <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-51" data-mp="qkyokhd3q0hp">The tools we run on</p>
          <ul className="mt-6 grid gap-x-10 border-t border-hairline sm:grid-cols-2 lg:grid-cols-3" data-id="element-52" data-mp="cl71lr4lx9rk">
            {toolset.map(tool => <li key={tool.name} className="flex items-baseline justify-between gap-4 border-b border-hairline py-4" data-id="element-53" data-mp="hlbj9kh94ajd">
                <span className="text-small font-medium text-ink" data-id="element-54" data-mp="7lufx9ph28qk">{tool.name}</span>
                <span className="text-small text-muted" data-id="element-55" data-mp="7nxewj8lrc7f">{tool.use}</span>
              </li>)}
          </ul>
        </Reveal>
      </Container>
    </Section>;
}